import APP from '../../../main.js'
import InvestmentAggregation from './InvestmentAggregation'

class TotalInvestment extends InvestmentAggregation {
  get name(){
    return 'Total'
  }
  get asset_class(){
    return 'Total'
  }
  set asset_class(v){}
  get investments(){
    return this._investments||[]
  }
  set investments(external_investments){
    if(external_investments.length > 0){
      var invs = external_investments.filter((inv) => {
        return (inv.entity_id === this.entity_id) && ((inv.type === 'AssetClassInvestment')||(inv.type === 'FeeInvestment'))
      }).map((ac) => {
        ac.investments = external_investments.filter((inv) => {
          if (inv.reporting_asset_class && ac.reporting_asset_class){
            return (inv.reporting_asset_class === ac.reporting_asset_class)&&(inv.is_minor)
          }

          return (inv.asset_class === ac.asset_class)&&(inv.is_minor)
        })
        return ac
      })
      this._investments = invs
    }
  }
  // Returns flat investments from minor to major
  get reverse(){
    return this.flat.reverse()
  }
  setInvestmentReturns(){
    this.reverse.forEach(inv => inv.compressIrs())
  }
}

export default TotalInvestment
